import React from 'react';

const Students = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Students</h1>
      <p className="text-gray-600">Student management coming soon...</p>
    </div>
  );
};

export default Students;